import { uniq, debounce } from "lodash";
import React, { useState, useEffect, useRef } from "react";
import Autosuggest from "react-autosuggest";

export const FilterSearch = ({ fields = [], fieldSearch = "", setFieldSearch }) => {
    const [fieldSuggestions, setFieldSuggestions] = useState([]);
    const fieldsRef = useRef(fields);

    useEffect(() => {
        fieldsRef.current = fields;
    }, [fields]);

    const getSuggestions = value => {
        const inputValue = (value && value?.toString()?.trim()?.toLowerCase()) || "";
        return uniq(
            fieldsRef.current
                .map(field => field?.label)
                .sort()
                .filter(field => field?.toString()?.toLowerCase().includes(inputValue))
        );
    };

    const debouncedOnSuggestionsFetch = useRef(
        debounce(value => {
            const suggestions = getSuggestions(value);
            setFieldSuggestions(suggestions);
        }, 500)
    );

    useEffect(() => {
        return () => {
            debouncedOnSuggestionsFetch.current.cancel();
        };
    }, []);

    const getSuggestionValue = suggestion => suggestion;

    const renderSuggestion = suggestion => <div>{suggestion}</div>;

    const onSuggestionsFetchRequested = ({ value }) => {
        debouncedOnSuggestionsFetch.current(value);
    };

    const onSuggestionsClearRequested = () => {
        setFieldSuggestions([]);
    };
    return (
        <>
            <Autosuggest
                suggestions={fieldSuggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                shouldRenderSuggestions={() => true}
                onSuggestionSelected={(e, { suggestion }) => setFieldSearch(suggestion)}
                inputProps={{
                    type: "text",
                    placeholder: "Field Finder...",
                    value: fieldSearch ? fieldSearch?.toString() : "",
                    className: "custom-input form-control",
                    onChange: (e, { newValue }) => {
                        setFieldSearch(newValue);
                    }
                }}
            />
            <i
                className="fas fa-times cursor-pointer"
                onClick={() => {
                    debouncedOnSuggestionsFetch.current.cancel();
                    setFieldSearch("");
                    setFieldSuggestions([]);
                }}
            ></i>
        </>
    );
};
